<div class="row">

	<!-- Top Panel -->
	<div class="col-sm-12">
	
		<!-- Keywords -->
		<div class="dropdown col-sm-6">
			<button class="btn btn-ef btn-sm dropdown-toggle" type="button" data-toggle="dropdown" style="margin-bottom: 10px">
				<i class="fa fa-info-circle" aria-hidden="true"></i>
				KEYWORDS
				<span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li *ngFor="let keyword of mAvailableKeywords" onmousedown="return false;" (click)="addKeyword(keyword)">
					<a style="cursor: pointer;">
						<i [ngClass]="keyword.classes" aria-hidden="true"></i>
						{{keyword.name}}
					</a>
				</li>
			</ul>
		</div>
		
		<!-- Recipients Label -->
		<div class="col-sm-6" style="color: #f57300">
			RECIPIENTS
		</div>
		
	</div>
	
	<!-- Email Subject/Body -->
	<div class="col-sm-6">
		<div class="panel panel-drk-ornge" style="border-color: #f57300">
			<div class="panel-body">
			
				<!-- Email Subject -->
				<input [(ngModel)]="mSubjectData.value" (ngModelChange)="mSubjectData.object_value=$event" type="text" class="form-control input-sm" style="width: 100%" placeholder="SUBJECT LINE">
				<br />
				
				<!-- Email Body -->
				<div 
					id="emailBody_{{mUniqueIndex}}" 
					contenteditable="true" 
					[(appContentEditable)]="mBodyData.value"
					[keywords]="mAvailableKeywords"
					(modelChange)="mBodyData.value = $event; mBodyData.object_value = $event;"
					class="form-control eftextarea" 
					style="min-height: 163px; font-size: 18px; width: auto"
					>
				</div>
			</div>
		</div>
	</div>
	
	<!-- Recipients (To Users/To Group/To Email Address) -->
	<div class="col-sm-6">
		
		<!-- Add User -->
		<button (click)="addDataForProperty(mProperty_ToUser)" style="margin-right: 4px;" type="button" class="btn btn-ef btn-sm">
			+
			<span class="glyphicon glyphicon-user"></span>
			Add User
		</button>
		
		<!-- Add Group -->
		<button (click)="addDataForProperty(mProperty_ToGroup)" style="margin-right: 4px;" type="button" class="btn btn-ef btn-sm">
			+
			<span class="glyphicon glyphicon-option-vertical"></span>
			Add Group
		</button>
		
		<!-- Add Email Address -->
		<button (click)="addDataForProperty(mProperty_ToEmail)" style="margin-right: 4px;" type="button" class="btn btn-ef btn-sm">
			+
			<span class="glyphicon glyphicon-envelope"></span>
			Add Email
		</button>
		
		<br />
		<br />
		
		<!-- Added Recipients -->
		<div class="panel panel-drk-ornge" style="border-color: #f57300">
			<div class="panel-body">
				<ng-container *ngIf="mAction.data != null">
					<ng-container *ngFor="let data of mAction.data">
						<app-email-address-editor *ngIf="data.property.property == mProperty_ToEmail"
							[mData]="data"
							(removeClicked)="removeData(data)"
							>
						</app-email-address-editor>
						<app-user-selector *ngIf="data.property.property == mProperty_ToUser"
							[mData]="data"
							(removeClicked)="removeData(data)"
							>
						</app-user-selector>
						<app-user-group-selector *ngIf="data.property.property == mProperty_ToGroup"
							[mData]="data"
							(removeClicked)="removeData(data)"
							>
						</app-user-group-selector>
					</ng-container>
				</ng-container>
			</div>
		</div>
	</div>
	
</div>
